export function parseDateString(value) {
  if (!value) return null

  const ymMatch = value.match(/^(\d{4})-(\d{2})-$/)
  if (ymMatch) {
    const [, year, month] = ymMatch
    return new Date(`${year}-${month}-01T00:00:00`)
  }

  const dmyMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})$/)
  if (dmyMatch) {
    const [, day, month, year] = dmyMatch
    return new Date(`${year}-${month}-${day}T00:00:00`)
  }

  const d = new Date(value)
  return isNaN(d) ? null : d
}
